import { useMemo } from "react";

export interface GitLabSourceSettingsText {
  projectsLabelText: string;
  projectsPlaceholderText: string;
  projectsHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useGitLabSourceSettingsText = (
  t: (key: string) => string,
): GitLabSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.gitlab.${key}`);

    return {
      projectsLabelText: tKey("projectsLabel"),
      projectsPlaceholderText: tKey("projectsPlaceholder"),
      projectsHintText: tKey("projectsHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
